// Утилиты для работы с JWT токеном в веб-приложении (localStorage)

const JWT_TOKEN_KEY = "jwt_token"
const USER_UID_KEY = "user_uid"

// Сохранить JWT токен
export const saveJwtToken = (token) => {
  try {
    if (!token) {
      // console.warn("[v0][authStorage] Попытка сохранить пустой токен")
      return false
    }
    localStorage.setItem(JWT_TOKEN_KEY, token)
    // 
    return true
  } catch (error) {
    // console.error("[v0][authStorage] Ошибка сохранения JWT токена:", error)
    return false
  }
}

// Получить JWT токен
export const getJwtToken = () => {
  try {
    const token = localStorage.getItem(JWT_TOKEN_KEY)
    // 
    return token
  } catch (error) {
    // console.error("[v0][authStorage] Ошибка получения JWT токена:", error)
    return null
  }
}

// Удалить JWT токен
export const clearJwtToken = () => {
  try {
    localStorage.removeItem(JWT_TOKEN_KEY)
    // 
    return true
  } catch (error) {
    // console.error("[v0][authStorage] Ошибка удаления JWT токена:", error)
    return false
  }
}

// Сохранить UID пользователя
export const saveUserUid = (uid) => {
  try {
    if (!uid) {
      console.warn("[v0][authStorage] Попытка сохранить пустой UID")
      return false
    }
    localStorage.setItem(USER_UID_KEY, uid)

    return true
  } catch (error) {
    console.error("[v0][authStorage] Ошибка сохранения UID:", error)
    return false
  }
}

// Получить UID пользователя
export const getUserUid = () => {
  try {
    const uid = localStorage.getItem(USER_UID_KEY)
    // 
    return uid
  } catch (error) {
    // console.error("[v0][authStorage] Ошибка получения UID:", error)
    return null
  }
}

// Удалить UID пользователя
export const clearUserUid = () => {
  try {
    localStorage.removeItem(USER_UID_KEY)
    // 
    return true
  } catch (error) {
    // console.error("[v0][authStorage] Ошибка удаления UID:", error)
    return false
  }
}

// Очистить все данные аутентификации
export const clearAllAuthData = () => {
  try {
    clearJwtToken()
    clearUserUid()
    clearUserClientUid()
    // 
    return true
  } catch (error) {
    // console.error("[v0][authStorage] Ошибка очистки данных:", error)
    return false
  }
}

// Проверить есть ли активная сессия
export const hasActiveSession = () => {
  const token = getJwtToken()
  const uid = getUserUid()
  const hasSession = !!(token && uid)
  // 
  return hasSession
}


// ✅ ДОБАВИТЬ В КОНЕЦ authStorage.js

const USER_CLIENT_UID_KEY = "user_client_uid"

export const saveUserClientUid = (uid) => {
  try {
    if (!uid) return false;
    localStorage.setItem(USER_CLIENT_UID_KEY, uid);
    return true;
  } catch { return false; }
}

export const getUserClientUid = () => {
  try { return localStorage.getItem(USER_CLIENT_UID_KEY); }
  catch { return null; }
}

export const clearUserClientUid = () => {
  try { localStorage.removeItem(USER_CLIENT_UID_KEY); return true; }
  catch { return false; }
}